import styles from "@/components/BuyCostImportModal/ImportFailure.module.css";

export const Failure = ({
    errorMessage
}) => {
    return (
        <div className={styles.failureContainer}>
            <svg xmlns="http://www.w3.org/2000/svg" width="180" height="181" viewBox="0 0 180 181" fill="none">
                <path
                    d="M7.5 165.5L90 23L172.5 165.5H7.5ZM90 143C92.125 143 93.9062 142.281 95.3438 140.844C96.7812 139.406 97.5 137.625 97.5 135.5C97.5 133.375 96.7812 131.594 95.3438 130.156C93.9062 128.719 92.125 128 90 128C87.875 128 86.0938 128.719 84.6562 130.156C83.2188 131.594 82.5 133.375 82.5 135.5C82.5 137.625 83.2188 139.406 84.6562 140.844C86.0938 142.281 87.875 143 90 143ZM82.5 120.5H97.5V83H82.5V120.5Z"
                    fill="#CD0710"/>
            </svg>
            <h2 className={styles.failureTitle}>Oops! Something Went Wrong</h2>
            <p className={styles.failureMessage}>
                {errorMessage}<br />
                Please try again or check you connection</p>
        </div>
    )
}